import { render, staticRenderFns } from "./FlashCardsPreview.vue?vue&type=template&id=f168872c&lang=pug&"
import script from "./FlashCardsPreview.vue?vue&type=script&lang=js&"
export * from "./FlashCardsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports